<template>
  <div className="modal fade show" tabIndex="-1" style="display:block;">
    <div className="modal-dialog modal-dialog-centered modal-sm">
      <img :src="spinner" alt="Spinner">
    </div>
  </div>
</template>

<script>
import {spinner} from '@/composables/file'

export default {
  name: "OverlayLoading",
  setup() {
    return {spinner}
  }
}
</script>

<style scoped>

</style>